import React from 'react'
import Input from 'components/input/Input'
import { stakeProps } from '../interfaces'
import { Wrapper } from './StakeStyled'

export default function Stake({
  currency,
  stake,
  setnumber,
  setinputStake,
  handleNotification,
  min,
  max,
  isZero,
  colors,
  toFix,
  size,
}: stakeProps) {
  return (
    <Wrapper data-testid='setStakeInput'>
      <h1>{currency}</h1>
      <Input
        number={stake}
        min={min}
        max={max}
        type='numbersAndDot'
        setnumber={setnumber}
        setinputStake={setinputStake}
        textcenter='center'
        currency={currency}
        handleNotification={handleNotification}
        isZero={isZero}
        innerBackground={colors.innerBackground}
        borderColor={colors.borderColor}
        radius='100px'
        toFix={toFix}
        size={size}
      />
    </Wrapper>
  )
}
